<section class="main-content">
    <div class="header">
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <h2>Asignar Permisos</h2>
    <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <section class="form-content">
            <mat-form-field>
                <mat-label>Permisos</mat-label>
                <mat-select formControlName="permissions" multiple>
                    <mat-option *ngFor="let permission of permissions$ | async" [value]="permission.permissionId">
                        {{ permission.description }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="form-content-footer">
                <button type="submit" [disabled]="formGroup.invalid" mat-raised-button color="primary">Agregar</button>
            </div>
        </section>
    </form>
</section>